import cn from 'classnames'
import React, { Dispatch, ReactElement, SetStateAction } from 'react'
import { useTranslation } from 'next-i18next'
import s from './QuantitySelector.module.scss'
import formStyles from 'stores/ooka_default/styles/common/Forms.module.scss'
import MinusQty from 'stores/ooka_default/components/icons/Minus'
import PlusIcon from 'stores/ooka_default/components/icons/PlusIcon'
// TODO: make `CartQuantity` component based on this one
// remove / add required props
type QuantitySelectorProps = {
    quantity: number
    setQuantity: Dispatch<SetStateAction<number>>
    isEditingDisabled?: boolean
    customMin?: boolean
    min?: number
    isAddingDisabled?: boolean
}

const MIN = 1
const MAX = 99

export const QuantitySelector = ({
    quantity,
    setQuantity,
    isEditingDisabled = false,
    isAddingDisabled = false,
    customMin = false,
    min = 0
}: QuantitySelectorProps) => {
    const { t } = useTranslation(['common', 'pdp'])

    const incrementQuantity = () => {
        const newValue = Math.min(quantity + 1, MAX)
        setQuantity(newValue)
    }

    const decrementQuantity = () => {
        let newValue = Math.max(quantity - 1, MIN)
        if (customMin) {
            newValue = Math.max(quantity - 1, min)
        }
        setQuantity(newValue)
    }

    return (
        <div className={cn(s['pdp-quantity'], 'pdp-qty')}>
            <div className={formStyles.root}>
                <button
                    className={cn('qty-label-left', 'qty-label')}
                    onClick={decrementQuantity}
                >
                    <MinusQty />
                </button>
                <input
                    type="text"
                    className="form-qty-indicator"
                    value={quantity}
                    readOnly
                />
                <button
                    className={cn('qty-label', 'qty-label-right')}
                    onClick={incrementQuantity}
                    disabled={isAddingDisabled}
                >
                    <PlusIcon isHidden={isAddingDisabled} />
                </button>
            </div>
        </div>
    )
}
